import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  listingInquiry: generateApiPath({ prefix: AuthLevel.AUTH, name: 'listing-inquiry' }),
  multipostListingInquiry: generateApiPath({ prefix: AuthLevel.AUTH, name: 'multipost-listing-inquiry' }),
}

export { paths }
